import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bstoggle',
	templateUrl:'./BSTogglePage.html',
	styles: [],
	styleUrls:['./BSTogglePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSTogglePage
{
	mdContent_173 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.toggle.BSToggle;
\`\`\``;
	mdContent_174 = `\`\`\`java
new BSDropDownToggle&lt;&gt;(BSDropDownToggleTitleLink&lt;?&gt; title, List&lt;?,?,?,?&gt; contents)
\`\`\``;
	mdContent_175 = `\`\`\`java
new BSDropDownToggle&lt;&gt;(BSDropDownToggleTitleButton&lt;?&gt; title, List&lt;?,?,?,?&gt; contents)
\`\`\``;
	mdContent_176 = `\`\`\`java
var title = new BSDropDownToggleTitleButton<>();
title.setText("Menu");
var contents = new List<>();
var toggle = new BSDropDownToggle<>(title, contents);
\`\`\``;
}
